<template>
  <div class="international-page">
    <div class="title-section">
      <div class="container">
        <div class="desc">
          <h1>A new way to podcast</h1>
          <p>
            Luminary is a premium podcast app that offers access to 40+ new podcasts alongside the thousands of shows you already love.
          </p>
        </div>

        <div class="side-banner">
          <img :src="banner">
        </div>
      </div>
    </div>
    <div class="container">
      <div class="form-section">
        <h4>Luminary is now available for podcast listeners in the US, UK, Canada, and Australia.</h4>
        <h5>Please enter your email below and be first to know when we expand in other markets.</h5>
        <SubscribeForm />
      </div>
    </div>
  </div>
</template>

<script>
import banner from '../../assets/images/group_8.png';
import SubscribeForm from '../../components/subscription/SubscribeForm';
import InternationalFooter from '../../components/InternationalFooter';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'InternationalPage',
  components: {
    SubscribeForm,
    InternationalFooter,
  },
  mixins: [PageMixin],
  data() {
    return {
      banner,
      pageName: 'International',
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/terms' || to.path === '/privacy') {
      next();
    } else {
      next('/international');
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";
.international-page {
  width: 100%;

  .title-section {
    padding: 80px 0 80px;
    background-color: $brand;
    color: #111111;
    position: relative;

    .desc {
      width: 50%;

      h1 {
        margin: 0px 0px 36px 0px;
        font-family: "ITC Clearface";
        font-weight: bold;
        font-size: 80px;
        letter-spacing: -2.5px;
        line-height: 80px;

        @media (max-width: 1024px) {
          font-size: 48px;
          line-height: 52px;
        }
      }

      p {
        font-size: 20px;
        letter-spacing: -0.26px;
        line-height: 28px;
        color: #111111;
      }
    }


    .side-banner {
      position: absolute;
      top: 30%;
      right: 0;
      height: 440px;

      img {
        height: 100%;
      }

      @media (max-width: 1650px) {
        right: -5%;
      }

      @media (max-width: 1500px) {
        right: -15%;
      }

      @media (max-width: 1250px) {
        right: -10%;
        height: 350px;
      }

      @media (max-width: 1120px) {
        right: -15%;
      }

      @media (max-width: 1024px) {
        height: 258px !important;
        right: -10%;
        top: 40%;
      }

      @media (max-width: 900px) {
        right: -15%;
      }

      @media (max-width: 768px) {
        width: 400px;
        left: 50%;
        top: 100%;
        overflow: hidden;

        transform: translateX(-50%) translateY(-50%);
      }
    }

    @media (max-width: 768px) {
      width: 100%;

      padding: 30px 0 150px;
    }

    .desc {
      @media (max-width: 1000px) {
        width: 50%;
      }

      @media (max-width: 768px) {
        text-align: center;
        margin: 0 auto;
      }

      @media (max-width: 600px) {
        width: 80%;
      }

      @media (max-width: 500px) {
        width: 90%;
      }
    }
  }

  .form-section {
    padding: 50px 0 0 0;
    margin-bottom: 160px;
    width: 50%;

    h4 {
      font-size: 30px;
      font-family: "ITC Clearface";
      letter-spacing: -0.39px;
      line-height: 34px;
      margin: 0 0 16px;
    }

    h5 {
      font-size: 20px;
      letter-spacing: -0.26px;
      line-height: 28px;
    }

    @media (max-width: 768px) {
      padding: 160px 0 60px 0;
      margin: 0 auto;
      text-align: center;
    }

    @media (max-width: 600px) {
      width: 80%;
    }

    @media (max-width: 500px) {
      width: 90%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/international/International.vue